import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from "recharts";

export function HiringTrendChart({ data }: { data: { label: string; hires: number }[] }) {
  const hasData = data.some((d) => d.hires > 0);
  if (!hasData) {
    return <p className="flex h-64 items-center justify-center text-sm text-slate-400">No new hires recorded in this window yet.</p>;
  }
  return (
    <ResponsiveContainer width="100%" height={256}>
      <LineChart data={data} margin={{ top: 8, right: 12, left: -12, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e7e6ea" vertical={false} />
        <XAxis dataKey="label" tick={{ fontSize: 12, fill: "#6e6d7a" }} axisLine={{ stroke: "#e7e6ea" }} tickLine={false} />
        <YAxis allowDecimals={false} tick={{ fontSize: 12, fill: "#6e6d7a" }} axisLine={false} tickLine={false} width={32} />
        <Tooltip
          contentStyle={{ borderRadius: 12, border: "1px solid #e7e6ea", fontSize: 13, boxShadow: "0 4px 16px -4px rgb(13 12 34 / 0.12)" }}
          labelStyle={{ color: "#0d0c22", fontWeight: 600 }}
          formatter={(value) => [`${value} hire${value === 1 ? "" : "s"}`, ""]}
        />
        <Line
          type="monotone"
          dataKey="hires"
          stroke="#6c3fd4"
          strokeWidth={2.5}
          dot={{ r: 4, fill: "#6c3fd4", strokeWidth: 0 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
